"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "amalfi": {
    "a3067dc1": [{
      "hkey": "d3e81540",
      "slug": "pastena-lone",
      "name": "Pastena-Lone",
      "primary": true,
      "skipSearch": false
    }],
    "pastena": [{
      "hkey": "d3e81540",
      "slug": "pastena-lone",
      "name": "Pastena-Lone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6b81cb79": [{
      "hkey": "3e7c1eee",
      "slug": "vettica",
      "name": "Vettica",
      "primary": true,
      "skipSearch": false
    }],
    "vettica-minore": [{
      "hkey": "3e7c1eee",
      "slug": "vettica",
      "name": "Vettica",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "db83febd": [{
      "hkey": "d3e81540",
      "slug": "pastena-lone",
      "name": "Pastena-Lone",
      "primary": true,
      "skipSearch": false
    }],
    "lone": [{
      "hkey": "d3e81540",
      "slug": "pastena-lone",
      "name": "Pastena-Lone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f7c327ef": [{
      "hkey": "68b44970",
      "slug": "tovere-san-pietro",
      "name": "Tovere San Pietro",
      "primary": true,
      "skipSearch": false
    }],
    "tovere": [{
      "hkey": "68b44970",
      "slug": "tovere-san-pietro",
      "name": "Tovere San Pietro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;